import React, { useState, useEffect } from 'react';
import { getUsers, createUser, deleteUser, adminResetPassword } from '../auth';

export default function UserManagement({ onClose }) {
  const [users, setUsers] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [resetTarget, setResetTarget] = useState(null);
  const [newUser, setNewUser] = useState({ name: '', email: '', password: '', role: 'user' });
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try { setUsers(await getUsers()); } catch {}
  }

  async function handleAdd(e) {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      await createUser(newUser);
      setSuccess(`User ${newUser.email} created`);
      setNewUser({ name: '', email: '', password: '', role: 'user' });
      setShowAdd(false);
      load();
    } catch (err) { setError(err.response?.data?.error || err.message); }
  }

  async function handleDelete(email) {
    if (!window.confirm(`Remove user ${email}?`)) return;
    setError(''); setSuccess('');
    try { await deleteUser(email); setSuccess(`${email} removed`); load(); }
    catch (err) { setError(err.response?.data?.error || err.message); }
  }

  async function handleResetPassword(e) {
    e.preventDefault();
    if (newPassword.length < 6) { setError('Password must be at least 6 characters'); return; }
    try {
      await adminResetPassword(resetTarget, newPassword);
      setSuccess(`Password reset for ${resetTarget}`);
      setResetTarget(null); setNewPassword('');
    } catch (err) { setError(err.response?.data?.error || err.message); }
  }

  return (
    <div className="settings-panel">
      <div className="settings-header">
        <h2>User Management</h2>
        <button className="compose-close" style={{ color: '#323130' }} onClick={onClose}>✕</button>
      </div>

      <div className="settings-body">
        {error && <div className="login-error" style={{ marginBottom: 12 }}>{error}</div>}
        {success && <div className="login-success" style={{ marginBottom: 12 }}>{success}</div>}

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ fontSize: 14, fontWeight: 600 }}>Users ({users.length})</h3>
          <button className="btn-primary" onClick={() => { setShowAdd(v => !v); setError(''); }}>
            {showAdd ? 'Cancel' : '+ Add user'}
          </button>
        </div>

        {showAdd && (
          <form onSubmit={handleAdd} className="add-user-form">
            <div className="login-field">
              <label>Name</label>
              <input value={newUser.name} onChange={e => setNewUser(p => ({ ...p, name: e.target.value }))} required />
            </div>
            <div className="login-field">
              <label>Email</label>
              <input type="email" value={newUser.email} onChange={e => setNewUser(p => ({ ...p, email: e.target.value }))} required />
            </div>
            <div className="login-field">
              <label>Password</label>
              <input type="password" value={newUser.password} onChange={e => setNewUser(p => ({ ...p, password: e.target.value }))} required minLength={6} />
            </div>
            <div className="login-field">
              <label>Role</label>
              <select value={newUser.role} onChange={e => setNewUser(p => ({ ...p, role: e.target.value }))}>
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            <button className="btn-primary" type="submit">Create user</button>
          </form>
        )}

        <table className="users-table">
          <thead>
            <tr><th>Name</th><th>Email</th><th>Role</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.email}>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td><span className={`role-badge role-${u.role}`}>{u.role}</span></td>
                <td className="user-actions">
                  <button onClick={() => { setResetTarget(u.email); setNewPassword(''); setError(''); }}>
                    Reset password
                  </button>
                  {u.email !== 'peterchen@flexisupport.com.au' && (
                    <button className="btn-remove" onClick={() => handleDelete(u.email)}>Remove</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {resetTarget && (
          <div className="reset-modal-backdrop">
            <div className="reset-modal">
              <h3>Reset password for {resetTarget}</h3>
              <form onSubmit={handleResetPassword}>
                <div className="login-field">
                  <label>New password</label>
                  <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required minLength={6} autoFocus />
                </div>
                <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                  <button className="btn-primary" type="submit">Set password</button>
                  <button className="btn-secondary" type="button" onClick={() => setResetTarget(null)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
